import React from 'react';
import { Lock, ChevronRight, Calendar } from 'lucide-react';
import { Snapshot } from '../types';
import { formatCurrency } from '../utils/formatters';
interface SnapshotHistoryProps {
  snapshots: Snapshot[];
  onViewAll: () => void;
  onOpenSnapshot: (snap: Snapshot) => void;
}
export function SnapshotHistory({
  snapshots,
  onViewAll,
  onOpenSnapshot
}: SnapshotHistoryProps) {
  return <section id="snapshot-history" className="mb-12 scroll-mt-8" data-id="element-416">
      <div className="flex items-center justify-between mb-6" data-id="element-417">
        <div data-id="element-418">
          <h2 className="text-xl font-semibold text-white flex items-center gap-2" data-id="element-419">
            <Calendar className="w-5 h-5 text-indigo-400" data-id="element-420" />
            Historical Snapshots
          </h2>
          <p className="text-sm text-slate-400 mt-1" data-id="element-421">
            Preserved month-end performance records
          </p>
        </div>
        <button onClick={onViewAll} className="text-sm text-indigo-400 hover:text-indigo-300 font-medium flex items-center gap-1 transition-colors" data-id="element-422">
          View All <ChevronRight className="w-4 h-4" data-id="element-423" />
        </button>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-4 snap-x" data-id="element-424">
        {snapshots.map(snap => <button key={snap.id} onClick={() => onOpenSnapshot(snap)} className="snap-start shrink-0 w-72 glass-panel rounded-2xl p-5 relative cursor-pointer text-left hover:border-white/20 transition-colors" data-id="element-425">
            <div className="absolute top-4 right-4 text-slate-500" data-id="element-426">
              <Lock className="w-4 h-4" data-id="element-427" />
            </div>

            <div className="mb-4" data-id="element-428">
              <h3 className="text-lg font-bold text-white" data-id="element-429">
                {snap.month} {snap.year}
              </h3>
              <p className="text-xs text-slate-500 mt-0.5" data-id="element-430">
                Finalized on {new Date(snap.lockedAt!).toLocaleDateString()}
              </p>
            </div>

            <div className="space-y-3" data-id="element-431">
              <div className="bg-black/20 rounded-xl p-3 border border-white/5" data-id="element-432">
                <p className="text-xs text-slate-400 mb-1" data-id="element-433">Total Volume</p>
                <p className="text-sm font-semibold text-white" data-id="element-434">
                  {formatCurrency(snap.totalVolume, true)}
                </p>
              </div>
              <div className="bg-black/20 rounded-xl p-3 border border-white/5" data-id="element-435">
                <p className="text-xs text-slate-400 mb-1" data-id="element-436">Total Revenue</p>
                <p className="text-sm font-semibold text-emerald-400" data-id="element-437">
                  {formatCurrency(snap.totalRevenue, true)}
                </p>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-438">
              <span className="text-xs text-slate-400" data-id="element-439">View Leaderboard</span>
              <ChevronRight className="w-4 h-4 text-slate-500" data-id="element-440" />
            </div>
          </button>)}
      </div>
    </section>;
}